var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-popup"},[_c('span',{staticClass:"month-pre",on:{"click":_vm.handlePreMonth}}),_c('span',{staticClass:"month-next",on:{"click":_vm.handleNextMonth}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }